export const regulations = [
  {
    link:
      'https://private.proverki.gov.ru/blob/news/admin/1657021090315/Регламент_подключения_и_интеграции_ФГИС_ЕРКНМ_3_от_05_07_2022.pdf',
    name: 'Регламент подключения и интеграции реестра ФГИС ЕРКНМ/ЕРП',
    isReg: true,
  },
  {
    link:
      'https://private.proverki.gov.ru/blob/news/admin2/1648569778010/Описание_новой_функциональности_для_пользователей_с_ролью_Работник_КНО.pdf',
    name: 'Описание новой функциональности для пользователей с ролью Работник КНО',
  },
  {
    link:
      'https://private.proverki.gov.ru/blob/news/admin2/1648569676788/Описание_новой_функциональности_для_пользователей_с_ролью_Прокурор.pdf',
    name: 'Описание новой функциональности для пользователей с ролью Прокурор',
  },
  {
    link:
      'https://private.proverki.gov.ru/blob/news/sysadmin_tp/1645681589612/ФГИС_ЕРКНМ_ЗЧ_Руководство_Пользователя_13_01_22.pdf',
    name: 'ФГИС ЕРКНМ ЗЧ Руководство Пользователя 13.01.22',
  },
  {
    link:
      'https://private.proverki.gov.ru/blob/news/sysadmin_tp/1645681589644/ФГИС_ЕРП_ЗЧ_Руководство_пользователя_13_01_22.pdf',
    name: 'ФГИС ЕРП ЗЧ Руководство пользователя 13.01.22',
  },
];
